import { render, staticRenderFns } from "./cost.vue?vue&type=template&id=4e323584&scoped=true&"
import script from "./cost.vue?vue&type=script&lang=js&"
export * from "./cost.vue?vue&type=script&lang=js&"
import style0 from "./cost.vue?vue&type=style&index=0&id=4e323584&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e323584",
  null
  
)

export default component.exports